import axios from 'axios';
import { baseUrl, phrUrl, phrUrlV2, baseUrlV2, pwsUrl, phrServiceUrl } from './env-variables';
import { usePracticeProviderContext } from '../context/PracticeProviderContext';

export function pwsApi(method, url, data, urlParameters) {
  return axios({
    method,
    baseURL: pwsUrl,
    url: `${url}`,
    headers: {
      token: window.localStorage.getItem('__token__'),
    },
    data,
    params: urlParameters,
    responseType: 'json',
    validateStatus(status) {
      return status >= 200 && status < 300; // default
    },
  });
}

export function chrApi(method, url, data, params, version = 1) {
  return axios({
    method,
    baseURL: version === 1 ? baseUrl : baseUrlV2,
    url: `${url}`,
    headers: {
      token: window.localStorage.getItem('__token__'),
    },
    data,
    params,
    responseType: 'json',
  });
}

export function phrApi(method, url, data, params) {
  return axios({
    method,
    baseURL: phrUrl,
    url: `${url}`,
    headers: {
      token: window.localStorage.getItem('__token__'),
    },
    data,
    params,
    responseType: 'json',
  });
}

export function phrApiV2(method, url, data, params) {
  return axios({
    method,
    baseURL: phrUrlV2,
    url: `${url}`,
    headers: {
      token: window.localStorage.getItem('__token__'),
    },
    data,
    params,
    responseType: 'json',
  });
}

export function phrServiceApi(method, url, data, params) {
  return axios({
    method,
    baseURL: phrServiceUrl,
    url: `${url}`,
    headers: {
      token: window.localStorage.getItem('__token__'),
    },
    data,
    params,
    responseType: 'json',
  });
}

export function uploadDocuments(url, data, params) {
  return axios({
    method: 'post',
    baseURL: phrUrl,
    url: `${url}`,
    headers: {
      'Content-Type': 'multipart/form-data',
      token: window.localStorage.getItem('__token__'),
    },
    data,
    params,
    responseType: 'json',
  });
}

export function chrFileUploadApi(url, data, params) {
  return axios({
    method: 'post',
    baseURL: baseUrl,
    url: `${url}`,
    headers: {
      'Content-Type': 'multipart/form-data',
      token: window.localStorage.getItem('__token__'),
    },
    data,
    params,
    responseType: 'json',
  });
}

export function pwsFileUploadApi(url, data, params) {
  return axios({
    method: 'post',
    baseURL: pwsUrl,
    url: `${url}`,
    headers: {
      'Content-Type': 'multipart/form-data',
      token: window.localStorage.getItem('__token__'),
    },
    data,
    params,
    responseType: 'json',
  });
}

export default function getAPIConfig() {
  const { token } = usePracticeProviderContext();
  const chrApiV1Config = {
    baseURL: baseUrl,
    headers: {
      token,
    },
    responseType: 'json',
  };
  const chrApiV2Config = {
    baseURL: baseUrlV2,
    headers: {
      token,
    },
    responseType: 'json',
  };
  const phrApiV1Config = {
    baseURL: phrUrl,
    headers: {
      token,
    },
    responseType: 'json',
  };
  const chrFileUploadConfig = {
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'multipart/form-data',
      token,
    },
  };
  const pwsConfig = {
    baseURL: pwsUrl,
    headers: {
      token,
    },
    responseType: 'json',
  };

  return { chrApiV1Config, chrApiV2Config, chrFileUploadConfig, phrApiV1Config, pwsConfig };
}

// export const chrApiV1Config = {
//   baseURL: baseUrl,
//   headers: {
//     token: window.localStorage.getItem('__token__'),
//   },
//   responseType: 'json',
// };
//
// export const chrApiV2Config = {
//   baseURL: baseUrlV2,
//   headers: {
//     token: window.localStorage.getItem('__token__'),
//   },
//   responseType: 'json',
// };
//
// export const phrApiV1Config = {
//   baseURL: phrUrl,
//   headers: {
//     token: window.localStorage.getItem('__token__'),
//   },
//   responseType: 'json',
// };
//
// export const chrFileUploadConfig = {
//   baseURL: baseUrl,
//   headers: {
//     'Content-Type': 'multipart/form-data',
//     token: window.localStorage.getItem('__token__'),
//   },
// };
